<template>
  <div>
    <v-snackbar v-model="snackBar.display" color="red" bottom right>
      {{ snackBar.text }}
      <v-btn
        text
        icon
        color="white"
        @click="snackBar = { display: false, text: '' }"
      >
        <v-icon v-text="$getIcon('mdiClose')"></v-icon>
      </v-btn>
    </v-snackbar>
    <select-contact-person-for-log
      :contact-person-list="contactPersonList"
      :contact-person="contactPerson"
      :form-validator="formValidator"
      :client="client"
      @refreshContactList="
        $emit('refreshContactList'), fetchCommunicationMediumContacts()
      "
      @contactPersonUpdate="$emit('contactPersonUpdate', $event)"
    ></select-contact-person-for-log>
    <v-card flat class="px-3">
      <v-card-text class="mb-12">
        <span class="red--text font-weight-bold">
          {{ formValidator.getError("non_field_errors") }}
        </span>
        <div v-if="logType === 'Communication'">
          <v-row no-gutters>
            <v-col cols="4">
              <span>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiInformationOutline')"
                ></v-icon>
              </span>
              <span class="subtitle-2 font-weight-bold mb-0">
                Log Type:
              </span>
              <v-row class="ml-0">
                <v-col
                  v-for="item in serviceLogType"
                  :key="item.value"
                  cols="auto"
                  class="text-center"
                >
                  <v-btn
                    :color="serviceLog === item.value ? 'blue darken-2' : ''"
                    @click="serviceLog = item.value"
                  >
                    <v-icon
                      :color="
                        serviceLog === item.value ? 'white' : 'blue darken-2'
                      "
                      v-text="item.icon"
                      size="20"
                    ></v-icon>
                  </v-btn>
                  <div class="caption font-weight-bold mt-1">
                    {{ item.name }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4">
              <span>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiSwapHorizontal')"
                ></v-icon>
              </span>
              <span class="subtitle-2 font-weight-bold mb-0">
                Medium Direction:
              </span>
              <v-row class="ml-0">
                <v-col
                  v-for="item in mediumDirectionType"
                  :key="item.name"
                  cols="auto"
                  class="text-center"
                >
                  <v-btn
                    :color="
                      formValues.medium_direction === item.name
                        ? 'blue darken-2'
                        : ''
                    "
                    @click="formValues.medium_direction = item.name"
                  >
                    <v-icon
                      :color="
                        formValues.medium_direction === item.name
                          ? 'white'
                          : 'blue darken-2'
                      "
                      size="20"
                      v-text="item.icon"
                    ></v-icon>
                  </v-btn>
                  <div class="caption font-weight-bold mt-1">
                    {{ item.name }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <div v-if="communicationMediums.length" class="my-2">
            <vue-carousel :show-button="communicationMediums.length > 10">
              <template slot="buttonsColumn">
                <span>
                  <v-icon
                    color="grey"
                    small
                    v-text="$getIcon('mdiPhoneSettingsOutline')"
                  ></v-icon>
                </span>
                <span class="subtitle-2 font-weight-bold mb-0">
                  Communication Medium:
                </span>
              </template>
              <template v-if="communicationMediums.length" slot="carousel">
                <v-card
                  flat
                  v-for="(medium, index) in communicationMediums"
                  :key="`category-carousel-${index}`"
                  class="text-center pointer mx-2 mt-2 mb-4"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-hover>
                        <v-card
                          v-on="on"
                          :class="
                            `elevation-${
                              medium.id === formValues.medium
                                ? `3 blue darken-2`
                                : `2`
                            }`
                          "
                          class="pointer"
                          @click="
                            $set(formValues, 'medium', medium.id),
                              (communicationMediums = [
                                ...communicationMediums
                              ]),
                              (radioContact = {})
                          "
                        >
                          <v-card-text class="px-0 py-3">
                            <v-icon
                              :color="
                                medium.id === formValues.medium
                                  ? 'white'
                                  : 'blue darken-2'
                              "
                              size="25"
                            >
                              {{ $options.mediumIcons[medium.icon] }}
                            </v-icon>
                          </v-card-text>
                        </v-card>
                      </v-hover>
                    </template>
                    <span>{{ medium.name }}</span>
                  </v-tooltip>
                </v-card>
              </template>
            </vue-carousel>
            <span v-if="contacts.length">
              <v-icon
                color="grey"
                small
                v-text="$getIcon('mdiPhoneSettingsOutline')"
              ></v-icon>
            </span>
            <span
              v-if="contacts.length"
              class="subtitle-2 font-weight-bold mb-0"
            >
              Select Contact:
            </span>
            <div
              v-if="formValues.medium && !contacts.length"
              class="subtitle-2 amber--text text--darken-2 mb-3"
            >
              No Contacts Available
            </div>
            <v-row>
              <v-col cols="12" class="pb-0" v-if="contacts.length">
                <v-radio-group
                  class="mt-0"
                  v-model="radioContact"
                  :mandatory="false"
                >
                  <v-radio
                    v-for="(contactInfo, index) in contacts"
                    :key="`${index}-contact`"
                    :value="contactInfo"
                  >
                    <template slot="label">
                      <div class="font-weight-bold">
                        <span
                          v-if="contactInfo.icon_name"
                          class="font-weight-regular"
                        >
                          <v-icon small>
                            {{ $options.mediumIcons[contactInfo.icon_name] }}
                          </v-icon>
                        </span>
                        {{ contactInfo.contact }}
                        <span>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            label
                            text-color="white"
                            small
                          >
                            {{ contactInfo.label_name }}
                          </v-chip>
                        </span>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col
                cols="12"
                class="pt-0"
                v-if="contacts.length && !radioContact.contact"
              >
                <span class="amber--text text--darken-2 body-2"
                  >No contact selected</span
                >
                <span class="red--text caption">{{
                  formValidator.getError("communication_log.contact") ||
                    formValidator.getError("contact")
                }}</span>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <span class="yellow--text body-2"
              >No communication medium present</span
            >
          </div>
          <div>
            <span class="red--text caption">{{
              formValidator.getError("communication_log.medium") ||
                formValidator.getError("medium")
            }}</span>
          </div>
          <div v-if="recentCommunication.length">
            <span>
              <v-icon
                color="grey"
                small
                v-text="$getIcon('mdiMessageTextOutline')"
              ></v-icon>
            </span>
            <span class="subtitle-2 font-weight-bold mb-0">
              Last Communication Details:
            </span>
            <div class="caption mt-2">
              <span class="grey--text text--darken-2">Date:</span>
              <span class="font-weight-bold ml-1 black--text">{{
                $dayjs(recentCommunication[0].created_at).format(
                  "YYYY-MM-DD, hh:mmA"
                )
              }}</span>
            </div>
            <p class="caption black--text mt-1">
              {{ recentCommunication[0].remarks }}
            </p>
          </div>
        </div>
        <div class="mt-2">
          <span>
            <v-icon
              color="grey"
              small
              v-text="$getIcon('mdiCalendarMonthOutline')"
            ></v-icon>
          </span>
          <span class="subtitle-2 font-weight-bold mb-0">
            Follow up date/time:
          </span>
          <v-row>
            <v-col md="6">
              <vue-date-time-picker-range
                v-model="followUpInfo.follow_up_datetime"
                color="primary"
                label="Select follow up date/time"
                :error-messages="
                  formValidator.getError('follow_up_datetime') ||
                    formValidator.getError(
                      'communication_log.follow_up_datetime'
                    )
                "
              ></vue-date-time-picker-range>
            </v-col>
            <v-col md="6">
              <v-select
                v-model="followUpInfo.follow_up_remind_before"
                label="Remind Before"
                suffix="in minutes"
                :items="timeChoices"
                :error-messages="
                  formValidator.getError('follow_up_remind_before')
                "
                :prependInnerIcon="$getIcon('mdiInformationOutline')"
              ></v-select>
            </v-col>
          </v-row>
        </div>
        <div class="mt-2">
          <span>
            <v-icon
              color="grey"
              small
              v-text="$getIcon('mdiFileCertificateOutline')"
            ></v-icon>
          </span>
          <span class="subtitle-2 font-weight-bold mb-0">
            Log Priority:
          </span>
          <v-row no-gutters>
            <v-col md="12">
              <v-chip-group v-model="priority" mandatory>
                <template v-for="(key, item) in priorityChoices">
                  <v-chip
                    :key="key"
                    :value="item"
                    small
                    :active-class="`${colorMapper[item]} white--text`"
                  >
                    <v-icon
                      size="16"
                      v-text="$getIcon('mdiFlash')"
                      class="mr-1"
                    ></v-icon>
                    {{ key }}
                  </v-chip>
                </template>
              </v-chip-group>
            </v-col>
          </v-row>
        </div>
        <div class="mt-2">
          <v-row align="center" align-content="center">
            <v-col v-if="showServiceLog" cols="6" class="pb-0">
              <span>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiCartOutline')"
                ></v-icon>
              </span>
              <span class="subtitle-2 font-weight-bold mb-0">
                Service type:
              </span>
              <p class="subtitle-2 font-weight-bold mb-0"></p>
              <div>
                <vue-select
                  :value="selectedService"
                  label="Select Service"
                  :error-messages="
                    formValidator.getError('service') ||
                      formValidator.getError(
                        'sub_stage_achievements[0].sales_achievements[0].service_chain'
                      )
                  "
                  :endpoint="
                    `/api/v1/crm/services/choices/?organization=${organization}&fields=id,name,per_price&department_filter=true`
                  "
                  @input="
                    $event => {
                      formValues.service = $event.id;
                      selectedService = $event;
                    }
                  "
                  item-text="name"
                  return-object
                  disabled
                ></vue-select>
              </div>
            </v-col>
            <v-col
              v-if="selectedService && !showServiceChain"
              cols="1"
              title="Attach to a service Chain"
            >
              <v-btn icon class="px-3" title="Attach to a service Chain">
                <v-icon
                  v-text="$getIcon('mdiLinkVariant')"
                  color="blue"
                  @click="showServiceChain = true"
                ></v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6" v-if="selectedService && showServiceChain">
              <p class="subtitle-2 font-weight-bold mb-0">
                Select Chain
              </p>
              <div>
                <vue-select
                  :value="selectedServiceChain"
                  label="Select Service Chain"
                  :error-messages="formValidator.getError('service_chain')"
                  :endpoint="
                    `/api/v1/crm/service-chains/choices/?organization=${organization}&client=${client.id}&service=${formValues.service}`
                  "
                  @input="
                    $event => {
                      if ($event) {
                        formValues.service_chain = $event.id;
                        selectedServiceChain = $event;
                      }
                    }
                  "
                  @click:clear="
                    () => {
                      formValues.service_chain = null;
                      selectedServiceChain = null;
                    }
                  "
                  item-text="name"
                  return-object
                  clearable
                  disabled
                ></vue-select>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-if="selectedService">
          <span class="subtitle-2 font-weight-bold mb-0">
            Requirements(upto three):
          </span>
          <v-row no-gutters align="center">
            <v-col
              cols="6"
              class="mr-4"
              v-for="(item, index) in formValues.jobPositions"
              :key="index"
            >
              <v-text-field
                v-model="formValues.jobPositions[index]"
                label="Job title"
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="auto"
              ><v-icon
                v-if="formValues.jobPositions.length < 3"
                v-text="$getIcon('mdiPlusCircleOutline')"
                color="blue"
                @click="addNewField()"
              ></v-icon>
              <v-icon
                v-if="formValues.jobPositions.length > 1"
                class="ml-4"
                v-text="$getIcon('mdiMinusCircleOutline')"
                color="blue"
                @click="deleteField()"
              ></v-icon>
            </v-col>
          </v-row>
          <price-section
            v-if="formValidator"
            :key="pricingKey"
            :selected-service="selectedService"
            :form-validator="formValidator"
            @updatePrice="formValues.servicePrice = $event"
            @updateQuantity="formValues.quantity = $event"
            class="mt-2"
          ></price-section>
          <div class="mt-2">
            <v-row>
              <v-col cols="6" class="pt-0">
                <span>
                  <v-icon
                    color="grey"
                    small
                    v-text="$getIcon('mdiInformationOutline')"
                  ></v-icon>
                </span>
                <span class="subtitle-2 font-weight-bold mb-0">
                  Select Stage:
                </span>
                <div>
                  <vue-select
                    :value="selectedStage"
                    label="Select Stage"
                    :error-messages="
                      formValidator.getError('stage') ||
                        (selectedStage
                          ? null
                          : formValidator.getError(
                              'sub_stage_achievements[0].sub_stage'
                            ))
                    "
                    :endpoint="
                      `/api/v1/crm/sales-stages/choices/?organization__slug=${organization}&fields=id,name`
                    "
                    @input="
                      $event => {
                        formValues.stage = $event.id;
                        selectedStage = $event;
                      }
                    "
                    item-text="name"
                    return-object
                  ></vue-select>
                </div>
              </v-col>
              <v-col v-if="selectedStage" cols="6" class="pt-0">
                <span>
                  <v-icon
                    color="grey"
                    small
                    v-text="$getIcon('mdiInformationOutline')"
                  ></v-icon>
                </span>
                <span class="subtitle-2 font-weight-bold mb-0">
                  Select Sub Stage:
                </span>
                <div>
                  <vue-select
                    :value="selectedSubStage"
                    label="Select Sub Stage"
                    :error-messages="
                      formValidator.getError(
                        'sub_stage_achievements[0].sub_stage'
                      )
                    "
                    :endpoint="
                      `/api/v1/crm/sales-sub-stages/choices/?sales_stage__id=${formValues.stage}&fields=id,name&department_filter=true`
                    "
                    @input="
                      $event => {
                        formValues.sub_stage = $event.id;
                        selectedSubStage = $event;
                      }
                    "
                    item-text="name"
                    return-object
                  ></vue-select>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="mt-4">
          <v-select
            v-model="formValues.remarks_options"
            :items="remarks_options"
            :remark-selected="remarkSelected"
            @change="remarkSelected"
            label="Log Remarks"
          ></v-select>
        </div>

        <div class="mt-2">
          <div>
            <v-textarea
              v-if="formValues.remarks_options === '14. Others'"
              v-model="formValues.remarks"
              label=""
              rows="2"
              :error-messages="
                formValidator.getError('remarks') ||
                  formValidator.getError('communication_log.remarks')
              "
              hint="Write down your other remarks here if any. Please start with 14. Others: 
              For Eg. 14. Others: Your Remarks here.
              "
            ></v-textarea>
          </div>
        </div>
      </v-card-text>

      <v-footer class="pt-0" fixed height="60">
        <v-row>
          <v-col class="text-right" md="12">
            <v-btn class="mr-2" text @click="$emit('close')">
              Cancel
            </v-btn>
            <v-btn class="mr-2" color="primary" @click="submitLog()">
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </v-footer>
    </v-card>
  </div>
</template>

<script>
import { FormValidator } from "rhr-core-shell";
import mediumIcons from "@/utils/mediumIcons.js";
import PriceSection from "./priceSection";
import selectContactPersonForLog from "./selectContactPersonForLog";
import VueCarousel from "@/components/common/layout_utils/VueCarousel";
import VueDateTimePickerRange from "@/components/common/form_utils/VueDateTimePickerRange";

export default {
  mediumIcons,
  components: {
    PriceSection,
    selectContactPersonForLog,
    VueCarousel,
    VueDateTimePickerRange
  },
  props: {
    contactPerson: {
      type: Object,
      required: false,
      default: () => {}
    },
    actionData: {
      type: Object,
      required: false,
      default: () => {}
    },
    client: {
      type: Object,
      required: true
    },
    contactPersonList: {
      type: Array,
      default() {
        return [];
      }
    },
    logType: {
      type: String,
      required: false,
      default: "Communication"
    },
    serviceChainInformation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      followUpInfo: {
        follow_up_remind_before: 0
      },
      serviceLogType: [
        {
          name: "General",
          value: "general",
          icon: this.$getIcon("mdiInformationOutline")
        },
        {
          name: "Service",
          value: "service",
          icon: this.$getIcon("mdiCartOutline")
        }
      ],
      mediumDirectionType: [
        {
          name: "Inbound",
          icon: this.$getIcon("mdiArrowDownBoldCircleOutline")
        },
        {
          name: "Outbound",
          icon: this.$getIcon("mdiArrowUpBoldCircleOutline")
        }
      ],
      radioContact: {},
      communicationMediums: [],
      formValues: {
        medium_direction: "Inbound",
        servicePrice: 0,
        quantity: 1,
        jobPositions: [""],
        ...this.actionData
      },
      formValidator: new FormValidator(),
      selectedService: null,
      selectedSubStage: null,
      selectedStage: null,
      selectedServiceChain: null,
      serviceLog: "service",
      showServiceLog: this.logType === "Process",
      showServiceChain: false,
      recentCommunication: "",
      contacts: [],
      timeChoices: [0, 10, 20, 30, 40, 50],
      loading: false,
      priority: "Normal",
      priorityChoices: {
        "Critical": "Hot(>80%)",
        "Important": "Warm(40%-80%)",
        "Normal": "Oppt(20%-40)",
        "Low": "New/Lost(<20%)",
      },
      colorMapper: {
        Critical: "red",
        Important: "orange",
        Normal: "green",
        Low: "blue",
      },   
      remarks_options: [
        "01. Paid job post purchased",
        "02. Trail job post availed",
        "03. Service Introduced",
        "04. Regular communication and follow up going on",
        "05. Vacancy already posted in merojob",
        "06. Bulk left, has not posted the vacancy in our portal",
        "07. Interested in services other than job post",
        "08. No Hiring at the moment",
        "09. Not interested in our service",
        "10. Multiple followups but no response",
        "11. Could not connect with concerned person- Temporary",
        "12. Could not connect with concerned person- Permanent",
        "13. Foreign Client/Job Seekers",
        "14. Others",
      ],
      snackBar: {
        display: false,
        text: ""
      },
      pricingKey: 0
    };
  },
  watch: {
    cpMedium(newVal) {
      if (newVal) {
        this.fetchCommunicationMediumContacts();
      }
    },
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    },
    serviceChainInformation: {
      handler(val) {
        if (Object.keys(val).length) {
          this.selectedService = val.service;
          this.formValues.service = val.service.id;
          this.selectedServiceChain = val.service_chain;
          this.formValues.service_chain = val.service_chain.id;
          this.serviceLog = "service";
          this.showServiceChain = true;
          this.showServiceLog = true;
          this.formValues.jobPositions = val.data["job_positions"] || [""];
          this.selectedService.per_price = val.price / val.quantity;
          this.selectedService.quantity = val.quantity;
          this.pricingKey += 1;
        }
      },
      immediate: true
    },
    serviceLog(val) {
      if (val === "general") {
        delete this.formValues["service"];
        this.showServiceLog = false;
        this.selectedService = null;
        this.selectedStage = null;
        this.selectedSubStage = null;
      } else this.showServiceLog = true;
    },
    selectedService(val) {
      if (val) {
        this.formValues.servicePrice = val.per_price;
      }
    },
    contactPerson: {
      handler() {
        this.getRecentCommunicationLog();
      },
      immediate: true
    }
  },
  computed: {
    organization() {
      return this.$store.state.shell.currentOrganizationId;
    },
    cpMedium() {
      if (this.formValues.medium && this.contactPerson.id) {
        return `${this.formValues.medium}--${this.contactPerson.id}`;
      }
      return "";
    }
  },
  mounted() {
    this.fetchCommunicationMediums();
    if (Object.keys(this.contactPerson).length) {
      this.getRecentCommunicationLog();
    }
  },
  methods: {
    addNewField() {
      let jobPositions = this.formValues.jobPositions;
      if (jobPositions.length < 3) {
        jobPositions.push("");
      }
    },
    remarkSelected(val){
      this.formValues.remarks = val
    },
    deleteField() {
      let jobPositions = this.formValues.jobPositions;
      if (jobPositions.length != 1) {
        this.formValues.jobPositions.pop();
      }
    },
    fetchCommunicationMediums() {
      const endpoint = `/api/v1/crm/communication-mediums/choices/?fields=id,name,icon&organization__slug=${this.$store.state.shell.currentOrganizationId}`;
      this.$axios.$get(endpoint).then(response => {
        this.communicationMediums = response;
      });
    },
    fetchCommunicationMediumContacts() {
      const endpoint = `/api/v1/crm/client-contact-person-medium-contacts/choices/?medium_id=${this.formValues.medium}&contact_person_id=${this.contactPerson.id}`;
      this.$axios.$get(endpoint).then(response => {
        this.contacts = response;
      });
    },
    getRecentCommunicationLog() {
      const endpoint = "/api/v1/crm/communication-log/choices/";
      const params = {
        log_ptr__client__slug: this.client.slug,
        log_ptr__organization__slug: this.organization,
        contacted_with: this.contactPerson.id,
        fields: "remarks",
        page_size: 1
      };
      this.$axios.$get(endpoint, { params: params }).then(response => {
        this.recentCommunication = response.results;
      });
    },
    //TODO@Rohit: needs refactor, followUpInfo should not be sent everytime
    getCommunicationLogData() {
      return {
        contacted_with: this.contactPerson.id,
        contact: this.radioContact.contact,
        contact_label: this.contacts.find(
          obj => (obj.contact = this.radioContact.contact)
        ).label_name,
        medium: this.formValues.medium,
        medium_direction: this.formValues.medium_direction,
        log_status: "Successful",
        remarks: this.formValues.remarks || "-",
        organization: this.organization,
        priority: this.priority,
        ...this.followUpInfo
      };
    },
    //TODO@Rohit: needs refactor , implementation of processlog
    createFormValues() {
      if (this.serviceLog === "general") {
        return {
          client: this.client.id,
          ...this.getCommunicationLogData()
        };
      } else {
        return {
          client: this.client.id,
          organization: this.organization,
          communication_log: this.getCommunicationLogData(),
          // process_log: {
          //   remarks: this.formValues.remarks || "-",
          //   organization: this.organization
          // },
          sub_stage_achievements: [
            {
              sub_stage: this.formValues.sub_stage,
              sales_achievements: [
                {
                  quantity: this.formValues.quantity,
                  price: Number(
                    this.formValues.servicePrice.replaceAll(",", "")
                  ),
                  data: {
                    job_positions: this.formValues.jobPositions.filter(x => x)
                  },
                  ...(this.formValues.service_chain
                    ? { service_chain: this.formValues.service_chain }
                    : { service: this.formValues.service })
                }
              ]
            }
          ]
        };
      }
    },
    validateFields() {
      if (
        !this.contacts.length ||
        (this.contacts && this.radioContact && !this.radioContact.contact)
      ) {
        return this.openCustomSnackBar(
          "Please select one of the communication medium to proceed."
        );
      }
      if (this.serviceLog !== "general" && !this.formValues.service) {
        return this.openCustomSnackBar(
          "Please select service type to proceed."
        );
      }
    },
    async submitLog() {
      if (await !this.validateFields()) {
        this.loading = true;
        let endpoint =
          this.serviceLog === "general"
            ? "/api/v1/crm/communication-log/"
            : "/api/v1/crm/client-substage-log/";
        this.$axios
          .$post(endpoint, this.createFormValues())
          .then(() => {
            this.$store.dispatch("shell/showSnackbar", {
              text: `Successfully created ${this.logType} Log!`
            });

            this.$emit("success");
          })
          .catch(error => {
            this.formValidator.setError(error.response.data);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    openCustomSnackBar(msg) {
      this.snackBar = {
        display: true,
        text: msg
      };
    }
  }
};
</script>
